// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"aee005a1","409":"1d2eb829","689":"0dbc74da","849":"c59b2d08"}[chunkId] + ".chunk.js";
};